import { subscribe, publish } from 'pubsub-js'; // Fixed to version 1.5.7 due to React (RBAM) having issue importing
const request = require('superagent');
import {get as getCookie, set as setCookie, remove as removeCookie } from 'js-cookie';
import xde from './xde';
import * as contentful from 'contentful';

/** @class MBHLauncherClass */
class MBHLauncherClass {
    /** @constructor */
    constructor() {
            // Public variables
            this._resetTimers;
            this._userInteractions = 'mousemove keydown wheel DOMMouseScroll mousewheel mousedown click DOMContentLoaded touchstart touchend touchcancel touchmove'.split(' ');
            this._inactivityTimer;
            this._logoutTimer;
            this._heartBeatInterval;
            this._checkInactiveInterval;
            this._alertTriggered = false;
            this._timeoutTriggered = false;
            this._iframe = null;
            this._redirectURL;
            /**
             * The Cross domain events object
             * @type {XDE}
             * @public
             */
            this.xde = xde || {};
            this.xdActive = false;

            // Private variables
            /** The configuranble options object*/
            let _options = LAUNCHER_CONFIG;
            /** The configuration object for the launcher */
            let _config = _options;
            /** The portal id of the current website */
            let _portalId = '';
            /** Flag which notifies if the user is active in the viewport */
            let _sessionActive = true;

            /** 
             * Function to subscribe to custom events 
             * @example
             * // Subscribe to event `sessionTimeout`
             * MBHLauncher.subscribe('sessionTimeout', function(event, data) {
             * // Code to handle session timeout
             * })
             * @type {function}
             * @param {string} eventName Name of the event to subscribe to
             * @param {function} eventCallback The handler function for the event
             * @public
             */
            this.subscribe = subscribe;
            /**
             * Function to trigger custom events
             * @example
             * // Trigger event `sessionTimeout`
             * MBHLauncher.trigger('sessionTimeout', {
             * // Data to be sent to the event listener
             * })
             * @type {function}
             * @param {string} eventName Name of the event to trigger
             * @param {*} eventData The data that needs to be sent to the subscriber
             * @public
             */
            this.trigger = publish;
            /**
             * Function to get `_options`
             * @return {Object} Value of `_options`
             * @private
             */
            this._getOptions = function() {
                return _options;
            };
            /**
             * Function to set `_options`
             * @param {Object} [options{}] Options object that is overridden by the user in the `initialize` function
             * @return {Object} Updated value of `_options`
             * @private
             */
            this._setOptions = function(options = {}) {
                _options = Object.assign({}, _options, options);
                return _options;
            };
            /**
             * Function to get `_config`
             * @return {Object} Value of `_config`
             * @private
             */
            this._getConfig = function() {
                return _config;
            };
            /**
             * Function to set `_config`
             * @param {Object} [config={}] Configuration object
             * @return {Object} Updated value of `_config`
             * @private
             */
            this._setConfig = function(config = {}) {
                _config = Object.assign({}, _config, config);
                return _config;
            };
            /**
             * Function to set logout redirect URL
             * @param {string} logoutURL for setitng the URL of logout
             * @private
             */
            this.setLogoutRedirect = function(logoutURL) {
                this._redirectURL = logoutURL;
            };
            /**
             * Function to get `_redirectURL`
             * @return {string} Value of `_redirectURL`
             * @public
             */
            this.getLogoutRedirect = function() {
                return this._redirectURL;
            };
            /**
             * Function to get `_language`
             * @return {string} Value of `_language`
             * @public
             */
            this.getLanguage = function() {
                return getCookie(this._getConfig().languageCookieName);
            };
            /**
             * Function to set `_language`
             * 
             * It also triggers `launcherDataLanguage` event after setting the value
             * @example
             * // Set language to `fr`
             * MBHLauncher.setLanguage('fr');
             * @param {string} [language=''] The guid of the active user
             * @return {string} Updated value of `_language`
             * @public
             */
            this.setLanguage = function(language = _config.launcherLanguage) {
                setCookie(this._getConfig().languageCookieName, language, {
                    domain: this._getConfig().cookieDomain
                });
                _config.cookieDomains.forEach(domain => {
                    setCookie(this._getConfig().languageCookieName, language, {
                        domain: domain
                    });
                });
                // Notify the site integrator that the language of the launcher is changed
                this.trigger('launcherDataLanguage', language);
                return language;
            };
            /**
             * Function to get `_portalId`
             * @return {string} Value of `_portalId`
             * @public
             */
            this.getPortalId = function() {
                return _portalId;
            };
            /**
             * Function to set `_portalId`
             * 
             * It also triggers `launcherPortalId` event after setting the value
             * @example
             * // Set portalId to `RD`
             * MBHLauncher.setPortalId('RD');
             * @param {string} [portalId=''] The portalId of the current portal
             * @return {string} Updated value of `_portalId`
             * @public
             */
            this.setPortalId = function(portalId = '') {
                _portalId = portalId;
                // Notify the site integrator that the portalId of the launcher is changed
                this.trigger('launcherPortalId', _portalId);
                return _portalId;
            };
            /**
             * Function to get `_sessionActive`
             * @return {boolean} Value of `_sessionActive`
             * @private
             */
            this._getSessionActive = function() {
                return _sessionActive;
            };
            /**
             * Function to set `_sessionActive`
             * @param {boolean} [sessionActive=true] Whether user is active on the page
             * @return {boolean} Updated value of `_sessionActive`
             * @private
             */
            this._setSessionActive = function(sessionActive = true) {
                _sessionActive = sessionActive;
                return _sessionActive;
            };

            this.setCookie = setCookie;
            this.getCookie = getCookie;
            this.delCookie = removeCookie;
            /**
             * Function that acts as a wrapper over xde.sendTo
             */
            this.xde.send = (msg, data) => {
                this.xde.sendTo(this._iframe, msg, data);
            };

        }
        /** 
         * Function to attach event listeners to a class function
         * 
         * This is as per recommended way of binding class functions to `document.addEventListener`
         * @private
         */
    _inactivityListeners() {
            this._resetTimers = this._resetInactivityTimer.bind(this);
            this._addEventListeners();
        }
        /**
         * Function to add event listeners to the event types in `this._userInteractions` array
         * @private
         */
    _addEventListeners() {
            this._userInteractions.forEach((interaction) => {
                document.addEventListener(interaction, this._resetTimers);
            });
        }
        /**
         * Function to remove event listeners from the event types in `this._userInteractions` array
         * @private
         */
    _removeEventListeners() {
            this._userInteractions.forEach((interaction) => {
                document.removeEventListener(interaction, this._resetTimers);
            });
        }
        /**
         * Function to check the activity of the user and trigger sessions timeout events
         * 
         * It triggers `sessionTimeoutAlert` event after user inactive on the site for more
         * than the `_config.inactivityTime`
         * 
         * It triggers `sessionTimeout` event after the user hasn't taken any action after the
         * `sessionTimeoutAlert` event with the `_config.logoutTime`
         * 
         * @private
         */
    _resetInactivityTimer() {
            const _config = this._getConfig();
      //      console.log(`User activity on screen!`);
            if (this.xdActive === true) {
                this.xde.sendTo(this._iframe, 'xdUserActive', { sessionActive: !this._alertTriggered });
            } else {
                this._setSessionActive(!this._alertTriggered);
            }
            clearTimeout(this._inactivityTimer);
            this._inactivityTimer = window.setTimeout(() => {
              //  console.log(`User inactive in more than ${_config.inactivityTime}ms`);
                if (this.xdActive === true) {
                    this.xde.sendTo(this._iframe, 'xdUserActive', { sessionActive: false });
                } else {
                    this._setSessionActive(false);
                }
            }, _config.inactivityTime);
        }
        /**
         * Function to get the launcher portal data from the backend
         * 
         * It triggers a `launcherDataRecieved` custom event on success
         * 
         * It triggers a `launcherDataError` custom event of error
         * 
         * @return {undefined}
         * @example
         * // Request launcher json data from the server and handle the response
         * MBHLauncher.subscribe('launcherDataRecieved', function(evt, data){
         * // console.log(data);
         * });
         *  MBHLauncher.subscribe('launcherDataError', function(evt, data){
         * // console.log(data);
         * });
         * MBHLauncher.getJSON();
         * @public
         */
    getJSON() {
            if (this.xdActive === true) {
                this.xde.sendTo(this._iframe, 'xdGetJSON');
                return;
            }
            this._getLinksFromAPI();
            //this._getLinksFromContentful();
        }

    _getLinksFromAPI() {
            const _config = this._getConfig();
            // console.log(`Get portals json called!`);
            request.get(_config.apiLauncher)
                .withCredentials()
                //.set(_config.headerSession, this.getSessionCookie())
                .set(_config.headerLanguage, this.getCookie(_config.languageCookieName))
                .query({
                    portalId: this.getPortalId(),
                    typeId: 4 // TypeId for the card component added here.
                })
                .end((err, res) => {
                    if (err || !res.ok) {
                    // console.log(`launcherDataError! -->`, err);
                        // Notify the site integratory that there was an error
                        this._errorHandler(err, 'launcherDataError');
                    } else {
                        if (res.status === 303 || res.status === 302) {
                            return;
                        }
                    //  console.log(`launcherDataRecieved! -->`, res.body);
                        // Notify the site integrator that launcher data is received
                        this.trigger('launcherDataRecieved', res.body);
                    }
                });
        }

    _getLinksFromContentful() {
            const _config = this._getConfig();
            let client = contentful.createClient({
                host: _config.contentful.contentfulHost,
                space: _config.contentful.spaceId,
                environment: _config.contentful.environment,
                accessToken: _config.contentful.token
            });
            client.getEntries(Object.assign({
                content_type: _config.contentful.portalListContentType,
                include: 2,
                locale: this.language
              }, { 'fields.entryTitle[in]': _config.contentful.entry_title })).then((res) => {
                /*
                if (res.status === 303 || res.status === 302) {
                    return;
                }*/
                //  console.log(`launcherDataRecieved! -->`, res.body);
                // Notify the site integrator that launcher data is received
                let quicklinks = this._convertContentfulToJSON(res);
                if (quicklinks) {
                    this.trigger('launcherDataRecieved', quicklinks);
                }
            })
            .catch(err => {
                this._errorHandler(err, 'launcherDataError');
             });
        }
    
    _convertContentfulToJSON(body) {
            let segmentsCookie = this.getSessionCookie('LAUNCHER_PORTAL_USER_SEGMENTS');
            if (segmentsCookie && body && body.hasOwnProperty('items') && body.items.length > 0 && body.items[0].hasOwnProperty('fields') && body.items[0].fields.portalItems && body.hasOwnProperty('includes') && body.includes.hasOwnProperty('Entry')) {
                let order = body.items[0].fields.portalItems;
                let content = body.includes.Entry;
                let itemsDetail = order
                                    .map((portalItem) => portalItem.hasOwnProperty('sys') && portalItem.sys.hasOwnProperty('id') ? portalItem.sys.id : null)
                                    .map((portalItem) => content.find(item => item.hasOwnProperty('sys') && item.sys.hasOwnProperty('id') && item.sys.id == portalItem, portalItem), content)
                let portalList = segmentsCookie
                                    .split("|")
                                    .map(portal => portal.substr(0, portal.indexOf("_")?portal.indexOf("_"):portal.length))
                                    .reduce((list, portal) => list.includes(portal) ? list : [...list, portal], []);
                let links = itemsDetail
                                    .filter(portalItem => 
                                        (portalItem.hasOwnProperty('fields') && portalItem.fields.hasOwnProperty('portalId') && portalList.includes(portalItem.fields.portalId))
                                    , portalList)
                                    .map((portalItem) => {
                                        if (portalItem.hasOwnProperty('fields') && portalItem.fields.hasOwnProperty('portalId') && portalItem.fields.hasOwnProperty('portalUrl') && portalItem.fields.hasOwnProperty('portalTitle')) {
                                            return { "id": portalItem.fields.portalId, "url": portalItem.fields.portalUrl, "text": portalItem.fields.portalTitle, "image":null, "icon":null, "target":null, "atm":null, "permissionCode":null ,"value":null, "href":null }
                                        } else {
                                            return {}
                                        }
                                    });
                return {
                                        "module": {"typeID":null,"typeName":null,"variantName":null,"variantID":null,"header":null,"columns":null,"fullBleed":null},
                                        "content":[
                                            {
                                                "links":links,
                                                "cartridges":null,
                                                "header1":"MyBusiness Hub",
                                                "subheader1":"Your single access to all your products & services",
                                                "content1":null,"items":null,"image":null,"caption":null,
                                                "link":{"url":null,"text":"MyBusiness Hub","image":null,"icon":null,"target":"_self","atm":null,"permissionCode":null,"value":null,"href":null,"id":null},
                                                "subHeader1":null,"onHover":null,"close":null,"icon":null,"url":null,"target":null,"atm":null,"text":null,"permissionCode":null,"value":null,"copyright":null,"language":null,"modules":null,"products":null,"product":null,"header2":"MyBusiness Hub","arrowPosition":null,"content2":null,"autoplay":"false"
                                            }
                                        ],
                                        "preview":null
                                    };
            } else {
                return "";
            }
    }
        /**
         * Function to keep the sessions alive based on the user interactions
         * 
         * Triggers `sessionKeptAlive` and `sessionKeepAliveError` events
         * @return {undefined}
         * @public
         */
    keepAlive(keepSessionAlive) {
            if (this.xdActive === true) {
                this._alertTriggered = false;
                this.xde.sendTo(this._iframe, 'xdUserActive', {
                    sessionActive: keepSessionAlive || this._getSessionActive()
                });
                return;
            }
            const _config = this._getConfig();
           // console.log(`Keep Alive called! -->`, this._getSessionActive(), _config.apiKeepAlive);
            request.post(_config.apiKeepAlive)
                .withCredentials()
                //.set(_config.headerSession, this.getSessionCookie())
                .set(_config.headerLanguage, this.getCookie(_config.languageCookieName))
                .set('Content-Type', 'application/json')
                .send({
                    sessionActive: keepSessionAlive || this._getSessionActive(),
                    portalId: this.getPortalId()
                })
                .end((err, res) => {
                    if (_config.version == 'v2') {
                        // ignore response and have checkstatus determine session status from IAM
                        this.trigger('sessionKeptAlive', res.body);
                        this._alertTriggered = false;
                        return;
                    }
                    if (err || !res.ok) {
                        // console.log(`sessionKeepAliveError! -->`, err);
                        // Notify the site integratory that there was an error
                        this._errorHandler(err, 'sessionKeepAliveError');
                    } else {
                        let timestamp;
                        if (res.status === 303 || res.status === 302) {
                            return;
                        }
                        if (res.body.hasOwnProperty('timestamp')) {
                            timestamp = res.body.timestamp;
                        }
                        else if (res.body.hasOwnProperty('expiresIn(sec)')) {
                            timestamp = res.body['expiresIn(sec)'];
                        } else {
                            // console.log(`'timestamp key not found in response object!'`);
                            return;
                        }
                        const _sessionTimeRemaining = parseInt(timestamp) * 1000; // In milliseconds

                        // console.log(`Session time remaining -->`, _sessionTimeRemaining);
                        // console.log(`InActivity timeout -->`, _config.inactivityTime);

                        if (_sessionTimeRemaining <= _config.inactivityTime && _sessionTimeRemaining > 0) {
                            if (!this._alertTriggered) {
                                this.trigger('sessionTimeoutAlert', _config.logoutTime);
                                this._alertTriggered = true;
                            }
                            return;
                        }

                        if (_sessionTimeRemaining <= 0) {
                            if (!this._timeoutTriggered) {
                                this.trigger('sessionTimeout', _config.logoutTime);
                                this._timeoutTriggered = true;
                            }
                            return;
                        }

                        //console.log(`sessionKeptAlive! -->`, res.body);
                        // Notify the site integratory that the session was kept alive
                        this.trigger('sessionKeptAlive', res.body);
                        this._alertTriggered = false;
                    }
                });
        }
        /**
         * Function to initialize the heartbeat call to validate that the user session is "active"
         * @public
         */
    heartBeat() {
            const _config = this._getConfig();
         //   console.log(`Heart Beat initialized!`);
            clearInterval(this._heartBeatInterval);
            this._heartBeatInterval = window.setInterval(() => {
                this.keepAlive();
            }, _config.heartBeatInterval);
        }
        /**
         * Function to initialize the check inactive call to validate that the user session is "active"
         * @public
         */
    checkInactive() {
            const _config = this._getConfig();
          //  console.log(`Check Status initialized!`);
            clearInterval(this._checkInactiveInterval);
            this._checkInactiveInterval = window.setInterval(() => {
                this.checkStatus();
            }, _config.checkStatusInterval);
        }
        /**
         * Function to delete the cookies
         */
    delCookies() {
            const _config = this._getConfig();
          //  console.log(`Deleting Cookies`);
            //Remove cookie on current domain
            _config.sessionCookiesNames.forEach(cookieName => {
                removeCookie(cookieName);
            });
            //Remove cookie on set domain
            _config.sessionCookiesNames.forEach(cookieName => {
                _config.cookieDomains.forEach(domain => {
                    removeCookie(cookieName, {
                        domain: domain
                    });
                });
            });
        }
        /**
         * Function to sign the user out of the current session
         * 
         * Triggers `sessionSignedOut` event
         * @return {undefined}
         * @public
         */
    signOut() {
        const _config = this._getConfig();
         //   console.log(`Signout called! -->`, this._getSessionActive());
            if (!this.xdActive) {
                this.trigger('sessionSignedOut');
            }
            this.delCookies();
            window.location.href = this.addOrReplaceParam(_config.logout, "redirect_uri", this.getLogoutRedirect());
        }
        /**
         * Function to check the user session status
         * 
         * Triggers `sessionSignedOut` event
         * @param {boolean} [noSessionSignOut=true] for invalid session, redirect to signOut function and page
         * @return {undefined}
         * @public
         */
    checkStatus() {
        const _config = this._getConfig();
        request.get(_config.checkStatus)
            .withCredentials()
            .end((err, res) => {
                if (err || !res.ok) {
                    // console.log(`sessionStatusError! -->`, err);
                    // Notify the site integratory that there was an error
                    this._errorHandler(err, 'sessionStatusError');
                } else {
                    // console.log(`launcherDataRecieved! -->`, res.body);
                    // Notify the site integrator that session status received
                    if (res.body.hasOwnProperty('session') && res.body.session != 'none') {
                        this.trigger('sessionStatusRecieved', res.body);
                        return;
                    }
                }
                this.trigger('sessionTimeout');
                this._timeoutTriggered = true;
            });
        }
        /**
         * Function to set the user session cookie
         * @param {String} token The user token to set
         */
    setSessionCookies(token = '') {
            const _config = this._getConfig();
            if ((typeof(token) === 'object' && Object.keys(token).length === 0 && token.constructor === Object) || token == '') return; // AD: disable blank token operation
            //set cookie on current domain
            _config.sessionCookiesNames.forEach(cookieName => {
                setCookie(cookieName, token);
            });
            //set cookie on set domain
            _config.sessionCookiesNames.forEach(cookieName => {
                _config.cookieDomains.forEach(domain => {
                    setCookie(cookieName, token, {
                        domain: domain
                    });
                });
            });
        }
        /**
         * 
         * @param {Object} error The error recieved from the endpoint
         * @param {string} customErrorEvent The custom error event to trigger
         * @private
         */
    _errorHandler(error = null, customErrorEvent = '') {
            if (customErrorEvent) {
                this.trigger(customErrorEvent, error);
            }
            // Notify the site integratory that there was an error
            this.trigger('launcherDataError', error);
        }
        /**
         * Function to initialize the MBHLauncher plugin
         * 
         * NOTE: This should be called, before the `MBHLauncher.getJSON` or any of the 
         * subscribe functionality.
         * @param {Object} [options={}] The options to override in the launcher config 
         * @param {Boolean} [xdActive=false] If the Launcher needs to be initialized as cross domain
         * @example
         * // Initialize the `MBHLauncher` and set a new launcher api endpoint
         * MBHLauncher.initialize({
         *  apiLauncher: "http://api.rogers.com/launcher"
         * })
         * MBHLauncher.getJSON();
         * @public
         */
    initialize(options = {}, xdActive = false) {
            this._setConfig(this._setOptions(options));
            const _config = this._getConfig();
            this._redirectURL = _config.logoutRedirect;
            if (xdActive === true) {
                this.xdActive = true;
                this._xdCreateLauncherIframe();
                this._xdRegisterEventListeners();
            }
            this._inactivityListeners();
            if (!xdActive) {
                this.xdActive = false;
                if (_config.version == 'v1') {
                    this.keepAlive();
                    this.heartBeat();
                } else if (_config.version == 'v2') {
                    if (_config.enableCheckInactive) {
                        this.checkStatus();
                        this.checkInactive();
                        document.addEventListener('visibilitychange', () => {
                            if (document.hidden) {
                                clearInterval(this._checkInactiveInterval);
                            } else {
                                this.checkStatus();
                                this.checkInactive();
                            }
                        });
                    }
                    if (_config.enableKeepAlive) {
                        this.keepAlive();
                        this.heartBeat();
                    }
                    if (_config.enableGetJSON) {
                        this.getJSON();
                    }
                }
            }
        }
        /**
         * Function to destroy the current launcher event listeners and timers
         * @example
         * // Destory the MBHLauncher event listeners on error
         * MBHLauncher.subscribe('launcherDataError', function(evt, data){
         *      MBHLauncher.destory();
         * });
         * MBHLauncher.getJSON();
         * @public
         */
    destroy() {
            // console.log(`Destroy function called!`);
            // console.log(`Clearing intervals and timeouts!`);
            clearTimeout(this._inactivityTimer);
            clearTimeout(this._logoutTimer);
            clearInterval(this._heartBeatInterval);
            clearInterval(this._checkInactiveInterval);

            if (this._resetTimers) {
                // console.log(`Removing listeners!`);
                this._removeEventListeners();
                this._resetTimers = null;
            }

            if (this.xdActive === true) {
                this.xde._reset();
                this._xdDestroyLauncherIframe();
            }
        }
        /**
         * Get session cookie from set of cookie names to be checked
         * @return {String} The cookie name
         */
    getSessionCookie() {
            const _config = this._getConfig();
            let sessionCookie;
            _config.sessionCookiesNames.forEach(cookieName => {
                if (getCookie(cookieName)) {
                    sessionCookie = getCookie(cookieName);
                }
            });
            return sessionCookie;
        }
        /**
         * Function to create callback for event listers for the luancher for cross domain functonality 
         * @param {String} xdEventName The name of the cross domain event
         * @return {Function} The callback function for the event listeners
         */
    createXDECallback(xdEventName) {
            let _this = this;
            return function(msg, payload) {
                _this.xde.sendTo(window.parent, xdEventName, {
                    msg: msg,
                    payload: payload
                });
            }
        }
        /**
         * Function to create callback for event listers for the luancher errors for cross domain functonality 
         * @param {String} xdEventName The name of the cross domain event
         * @return {Function} The callback function for the error event listeners
         */
    createXDEErrorCallback(xdEventName) {
            let _this = this;
            return function(msg, payload) {
                _this.xde.sendTo(window.parent, xdEventName, {
                    msg: msg,
                    payload: payload.message
                });
            }
        }
        /**
         * Function to create a cross domain Iframe
         */
    _xdCreateLauncherIframe() {
            const _config = this._getConfig();
            // Launcher URL should be in the .rogers.com domain and should have XDE initialized
            let _iframeURL = _config.launcherURL;
            this._iframe = document.createElement('iframe');
            // set language in the query param
            _iframeURL = this.addOrReplaceParam(_iframeURL, 'lang', _config.launcherLanguage);
            // set origin in the URL param
            _iframeURL = this.addOrReplaceParam(_iframeURL, 'origin', window.location.origin);
            // unique timestamp for cached URL's
            _iframeURL = this.addOrReplaceParam(_iframeURL, 'timestamp', Date.now());
            this._iframe.src = _iframeURL;
            this._iframe.width = 0;
            this._iframe.height = 0;
            this._iframe.style.display = 'none';
            document.body.appendChild(this._iframe);
            return this._iframe;
        }
        /**
         * Function to destroy the cross domain Iframe
         */
    _xdDestroyLauncherIframe() {
            if (this._iframe) {
                document.body.removeChild(this._iframe);
                this._iframe = null;
            }
        }
        /**
         * Function to register cross domain events.
         */
    _xdRegisterEventListeners() {
            this.xde.on('xdConnected', () => {
                this.xde.send('xdLauncherOptions', this._getConfig());
            });
            this.xde.on('xdError', (evt) => {
                this.trigger(evt.data.msg, evt.data.payload);
            });
            this.xde.on('xdEvent', (evt) => {
                this.trigger(evt.data.msg, evt.data.payload);
            });
        }
        /**
         * Function to get a URL parameter given a test URL
         * @param {String} name  The parameter name to retrieve
         * @param {String} url The URL to test
         * @return {String} The parameter value
         */
    getURLParam(name, url) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
            var regexS = '[\\?&]' + name + '=([^&#]*)';
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results == null ? null : decodeURIComponent(results[1]);
        }
        /**
         * Add a URL parameter (or modify if already exists)
         * @param {url}   string  url 
         * @param {param} string  the key to set
         * @param {value} string  value 
         */
    addOrReplaceParam(url, param, value) {
        param = encodeURIComponent(param);
        var r = "([&?]|&amp;)" + param + "\\b(?:=(?:[^&#]*))*";
        var a = document.createElement('a');
        var regex = new RegExp(r);
        var str = param + (value ? "=" + encodeURIComponent(value) : "");
        a.href = url;
        var q = a.search.replace(regex, "$1" + str);
        if (q === a.search) {
            a.search += (a.search ? "&" : "") + str;
        } else {
            a.search = q;
        }
        return a.href;
    }

}

/**
 * Instance of `MBHLauncherClass`
 * @instance
 */
export const MBHLauncher = new MBHLauncherClass();


// WEBPACK FOOTER //
// ./src/launcher.js